const ExceptionCodes = {
    "-1": "您的网络请求超时，请检查您的网络。",
    "9999": "未知错误"
}

export {
    ExceptionCodes
}


// WEBPACK FOOTER //
// ./src/config/exception.js